import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import usegetdata from '../../Hooks/useGetData';
import usedeletedata from '../../Hooks/useDeleteData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import {
  Add_Accountant_Tasks_Type,
  Delete_Specific_Accountant_Task,
  Get_All_Accountant_Tasks,
  Get_Error,
  Get_Specific_Accountant_Task,
  Update_Specififc_Account_Task,
} from '../Types';

export const Add_Accountant_Task_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/AccountantTasks`, body);

    dispatch({
      type: Add_Accountant_Tasks_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const Get_All_Accountant_Task_Action = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/AccountantTasks`);

    dispatch({
      type: Get_All_Accountant_Tasks,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const Get_Specific_Accountant_Task_Action = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/AccountantTasks/${id}`);

    dispatch({
      type: Get_Specific_Accountant_Task,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const Update_Specific_Accountant_Task_Action = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/AccountantTasks/${id}`, body);

    dispatch({
      type: Update_Specififc_Account_Task,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const Delete_Specific_Accountant_Task_Action = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/AccountantTasks/${id}`);

    dispatch({
      type: Delete_Specific_Accountant_Task,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
